export default "__VITE_ASSET__BrtbvM$e__"